<template>
    <v-menu
        v-if="menuEnabled"
        :disabled="disabled"
        :bottom="bottom"
        :left="left"
        :right="right"
        :top="top"
        :open-on-hover="openOnHover"
    >
        <w-btn slot="activator" :icon-name="iconName" :disabled="disabled" :icon-color="iconColor" :class="activatorButtonClass"></w-btn>
        <v-list>
            <template v-if="title">
                <v-list-tile>
                    <v-list-tile-title>
                        {{title}}
                    </v-list-tile-title>
                </v-list-tile>
                <v-divider></v-divider>
            </template>
            <v-list-tile
                v-for="action in menuActionsEnabled"
                :key="action.title"
                @click="emitAction(action)"
            >
                <v-list-tile-action v-if="prependIcon">
                    <v-icon :color="action.color">{{action.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{action.title}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="appendIcon">
                    <v-icon :color="action.color">{{action.icon}}</v-icon>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
    import {every, filter} from 'underscore'
    import WActionsMixin from '../../mixins/actions/w-actions-mixin'
    import WBtn from '../WBtn'

    /**
     * Simple menu component to display a selectable list of actions.
     */
    export default {
        name: 'WMenu',
        mixins: [WActionsMixin],
        components: {
            WBtn
        },
        props: {
            /**
             * The actions to display in the menu.
             */
            actions: {
                type: Array,
                required: true
            },
            /**
             * The actions to display in the menu.
             */
            disabled: {
                type: Boolean,
                default: false
            },
            /**
             * Append icon displayed in the menu
             */
            appendIcon: {
                type: Boolean,
                default: true
            },
            /**
             * Align the component towards the bottom
             */
            bottom: {
                type: Boolean,
                default: true
            },
            /**
             * Render the menu component.
             */
            enableMenu: {
                type: Boolean,
                default: true
            },
            /**
             * Activator button icon color.
             */
            iconColor: {
                type: String,
                default: ''
            },
            /**
             * Activator button icon name.
             */
            iconName: {
                type: String,
                default: 'more_vert'
            },
            /**
             * Align the component towards the left
             */
            left: {
                type: Boolean,
                default: true
            },
            /**
             * Open the actions menu on hover.
             */
            openOnHover: {
                type: Boolean,
                default: false
            },
            /**
             * Prepend icon displayed in the menu
             */
            prependIcon: {
                type: Boolean,
                default: false
            },
            /**
             * Remove the menu icon padding.
             */
            removeIconMargin: {
                type: Boolean,
                default: false
            },
            /**
             * Align the component towards the top
             */
            right: {
                type: Boolean,
                default: false
            },
            /**
             * Optional menu title
             */
            title: {
                type: String,
                default: ''
            },
            /**
             * Align the component towards the top
             */
            top: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            activatorButtonClass () {
                const vm = this
                return {
                    'mx-0': vm.removeIconMargin
                }
            },
            menuActionsEnabled () {
                return filter(this.actions, (action) => {
                    return typeof action.show === 'boolean' ? action.show : every(action.show, (condition) => condition === true)
                })
            },
            menuEnabled () {
                return this.enableMenu && this.menuActionsEnabled.length !== 0
            }
        }
    }
</script>
